import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/**
 * Image wrapper that scales/translates the inner <img> as it scrolls past.
 * The outer wrapper takes the className you pass as-is (no positioning forced).
 * Combine with `overflow-hidden` and a sized container to mask the parallax movement.
 */
export default function ParallaxImage({
  src,
  alt = "",
  className = "",
  innerClassName = "",
  intensity = 0.18,
  loading = "eager",
  testId,
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [`${-intensity * 100}%`, `${intensity * 100}%`]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.15, 1.05, 1.15]);

  return (
    <div ref={ref} className={`overflow-hidden ${className}`} data-testid={testId}>
      <motion.img
        src={src}
        alt={alt}
        loading={loading}
        style={{ y, scale }}
        className={`w-full h-full object-cover will-change-transform ${innerClassName}`}
      />
    </div>
  );
}
